import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { createComponent as cc } from 'react-fela';
import { PAGES, COLORS } from '../util/constants';

import animatedLogo from '../assets/S.gif';
import logoSvg from '../assets/logo.svg';

const StartPageWrapper = cc(_ => ({
  backgroundColor: 'white',
  width: '100%',
  height: '100%',
}));

const AnimatedLogoWrapper = cc(_ => ({
  position: 'fixed',
  top: '0',
  right: '0',
  bottom: '0',
  left: '0',
}));

const AnimatedLogo = cc(({ logo, size }) => ({
  backgroundImage: `url(${logo})`,
  backgroundSize: size,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  width: '100%',
  height: '100%',
  position: 'absolute',
}));

const ComingSoonLabel = cc(_ => ({
  fontSize: '14px',
  color: COLORS.COMING_SOON,
  fontWeight: '200',
  marginTop: '82vh',
  textAlign: 'center',
  position: 'absolute',
  width: '100%',
  small: {
    fontSize: '13px',
    marginTop: '85vh',
    zIndex: 10,
  },
}));

class StartPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: true,
      zoomin: true,
      slide: false,
      hideComingSoon: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ slide: true, hideComingSoon: true });
    }, 7100);
    setTimeout(() => {
      this.props.finished(PAGES.START_PAGE);
    }, 8100);
  }

  render() {
    const { zoomin, slide, hideComingSoon } = this.state;
    return (
      <StartPageWrapper>
        <AnimatedLogoWrapper>
          <AnimatedLogo
            logo={ slide ? logoSvg : animatedLogo }
            size={ slide ? '370px 370px' : '300px 300px' }
            className={ zoomin ? 'zoomIn' : '' } />
          <ComingSoonLabel className={ hideComingSoon ? 'hide' : '' }>
            Coming soon.
          </ComingSoonLabel>
        </AnimatedLogoWrapper>
      </StartPageWrapper>
    );
  }
}

export default StartPage;



// WEBPACK FOOTER //
// ./src/components/StartPage.js